import React from "react";
import { string, object, func } from "prop-types";
import { connect } from "react-redux";

import ProfileMenuItem from "../ProfileMenuItem";
import { verifyEmail } from "../../helper/api";
import { setLoading } from "../../helper/actions";

import "./profile-menu-mobile.m.css";

const ProfileMenuMobile = ({ type = "profile", member, navigateToPage, setLoading }) => {
  const changePasswordClick = () => {
    setLoading(true);

    // User needs to validate the email account so send out an email to verify
    verifyEmail(member.email).then(navigateToPage("/profile/change-password")).finally(setLoading(false));
  };

  const editProfileClick = () => navigateToPage("/profile/edit");

  return (
    <div className="profile-mobile-menu">
      <div styleName="wrapper">
        <ProfileMenuItem label="My Profile" isActive={type === "profile"} href="/profile" />
        <div onClick={editProfileClick}>
          <ProfileMenuItem label="Edit Profile" isActive={type === "edit-profile"} />
        </div>
        {member && !member["verification-status"].includes("social-") && (
          <div onClick={changePasswordClick}>
            <ProfileMenuItem label="Change Password" isActive={type === "change-password"} />
          </div>
        )}
        <ProfileMenuItem label="My Comments" isActive={type === "comments"} href="/my-comments" />
        <ProfileMenuItem label="Saved Articles" isActive={type === "saved_news"} href="/saved" />
      </div>
    </div>
  );
};

ProfileMenuMobile.propTypes = {
  type: string,
  member: object,
  navigateToPage: func,
  setLoading: func,
};

const mapStateToProps = (state) => ({
  member: state.member || null,
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenuMobile);
